import { render, staticRenderFns } from "./Boletines.vue?vue&type=template&id=6316811c&scoped=true"
import script from "./Boletines.vue?vue&type=script&lang=ts"
export * from "./Boletines.vue?vue&type=script&lang=ts"
import style0 from "./Boletines.vue?vue&type=style&index=0&id=6316811c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6316811c",
  null
  
)

export default component.exports